export default __webpack_public_path__ + "static/media/selecao.64e7c41b.webp";